import HeaderComponent from "../HeaderComponent";
import SectionComponent from "../SectionComponent";
import ImageComponent from "../ImageComponent";
import NavigationContainerComponent from "../NavigationContainerComponent";
import NavItemComponent from "../NavItemComponent";
import CartComponent from "../CartComponent";
import InnerSectionComponent from "../InnerSectionComponent";
import ProductsComponent from "../Products/ProductsComponent";
import FooterComponent from "../FooterComponent";
import TextComponent from "../TextComponent";
import Checkout from "../Checkout/Checkout";
import ButtonComponent from "../ButtonComponent";
import ProductDetailComponent from "../ProductDetail/ProductDetailComponent";

export var defaultComponents: { [key: string]: any } = {
  header: HeaderComponent,
  section: SectionComponent,
  image: ImageComponent,
  "navigation-container": NavigationContainerComponent,
  "nav-item": NavItemComponent,
  cart: CartComponent,
  inner_section: InnerSectionComponent,
  ProductsComponent: ProductsComponent,
  footer: FooterComponent,
  text: TextComponent,
  Checkout: Checkout,
  Button: ButtonComponent,
  ProductDetailComponent: ProductDetailComponent,
};
